






import { Component, Prop, Vue } from 'vue-property-decorator';
import mediumZoom from 'medium-zoom';

@Component
export default class MediumZoomGallery extends Vue {

  @Prop({ default: 'img' })
  private selector!: string;

  @Prop({ default: 'rgba(0,0,0,.55)' })
  private background!: string;

  mounted () {
    const images = this.$el.querySelectorAll(this.selector);
    mediumZoom(images, {
      background: this.background
    });
  }
}
